import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink } from "react-router-dom";
import "./layout.css";
import constant from "../js/constant";
import { ApiGetMethod } from "../js/helper";

import Cars2Cars_Logo from "./Cars2Cars_Logo.png";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { FaSistrix } from "react-icons/fa";
import { FaLock  } from "react-icons/fa";
import { Routes, Route, useNavigate } from "react-router-dom";

import SearchBar from "../searchBar";
import { FaRegUserCircle } from "react-icons/fa";
import { AiFillLock } from "react-icons/fa";
import invite from "../../image/invite.png";
import InviteModal from "../inviteModal/inviteModal";
import "bootstrap/dist/css/bootstrap.min.css";
import LoginModal from "../login/loginmodal";
import BottomNavbar from "./bottomNavBar";
import badge from '../index/inspectbadge.png'
import { Image } from "react-bootstrap";

function OffcanvasExample() {
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleModalClose = () => {
    setShowLoginModal(false);
  };

  const handleModalShow = () => {
    setShowLoginModal(true);
  };

  const [showAllPlanModal, setShowAllPlanModal] = useState(false);

  const handleAllPlanClose = () => {
    setShowAllPlanModal(false);
  };

  const handleAllPlanShow = () => {
    setShowAllPlanModal(true);
  };
  // const handleSectionClick = (sectionId) => {
  //   const section = document.getElementById(sectionId);
  //   if (section) {
  //     section.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  //canvas close when link open

  const [showSidebar, setShowSidebar] = useState(false);

  const handleSidebarToggle = () => {
    setShowSidebar(!showSidebar);
  };

  const handleNavLinkClick = () => {
    setShowSidebar(false);
  };

    const [canvasOpen, setCanvasOpen] = useState(false); // State to track canvas open/close

  const handleCanvasToggle = () => {
    setCanvasOpen(!canvasOpen);
  };

  // const [showModal, setShowModal] = useState(false);
  const [showSrearchModal, setshowSrearchModal] = useState(false); //search bar open

  const formData = new FormData();
  const [userName, setName] = useState("Welcome");
  const [loggedIn, setLoggedIn] = useState(false);
  const [websiteLinks, setWebsiteLinks] = useState({});
  const [faviconUrl, setFaviconUrl] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    let data = formData;
    let url = `${constant.baseurl}settings`;
    const favicon = document.querySelector('link[rel="shortcut icon"]');
    ApiGetMethod(url, data).then((response) => {
      if (response.error == false) {
        setWebsiteLinks(response.data);
        favicon.href = response.data.favicon;
      } else {
      }
    });
  }, []);
  const [userValueObject, setUserValueObject] = useState(
    localStorage.hasOwnProperty("user")
      ? JSON.parse(localStorage.getItem("user"))
      : ""
  );
  useEffect(() => {
    if (userValueObject) {
      setName(userValueObject.name);
      setLoggedIn(true);
    }
  }, []);
  const [showDropdown, setShowDropdown] = useState(false);

  function removeDataFromLocalStorage() {
    localStorage.clear();
    setName("Welcome");
    setLoggedIn(false);
  }

  const [showModal, setShowModal] = useState(false);
  const [selectedCity, setSelectedCity] = useState(
    localStorage.getItem("homeCity") === null
      ? "pune"
      : localStorage.getItem("homeCity")
  );
  const [searchTerm, setSearchTerm] = useState("");

  const cities = [
    "Pune",
    "New Mumbai",
    "Mumbai",
    "Thane",
    "Kalyan",
    "Pen Raigad",
    "Sindhudurg",
    "Ratnagiri",
    "Kolhapur",
    "Satara",
    "Sangli",
    "Solapur",
    "Pimpri Chinchwad",
    "Nashik",
    "Ahmednagar",
    "Shrirampur",
    "Dhule",
    "Jalgaon",
    "Aurangabad",
    "Jalna",
    "Beed",
    "Latur",
    "Osmanabad",
    "Nanded",
    "Amravati",
    "Buldhana",
    "Yavatmal",
    "Akola",
    "Nagpur",
    "Wardha",
    "Gadchiroli",
    "Chandrapur",
    "Gondia",
    "Bhandara",
    "Washim",
    "Hingoli",
    "Nandurbar",
    "Nagpur Gramin",
    "Malegaon",
    "Baramati",
    "Vashi",
    "Ambajogai",
    "Akluj",
    "Panvel",
    "Borivali",
    "Vasai Virar",
    "Kharad",
    "Parbhani",
    "Thane Rural",
    "Nashik Rural",
  ];

  const handleSelect = (city) => {
    setSelectedCity(city);
    // onChange(selectedCity)
    setShowModal(false);
    window.location.reload();
  };

  useEffect(() => {
    window.postcity = selectedCity;
    localStorage.setItem("homeCity", selectedCity);
  }, [selectedCity]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredCities = cities.filter((city) =>
    city.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleClose = () => setshowSrearchModal(false);
  const handleShow = () => setshowSrearchModal(true);

  // const handleSelect = (city) => {
  //   setSelectedCity(city);
  //   window.postcity = selectedCity;
  //   setShowModal(false);
  // };

  // const handleSearch = (event) => {
  //   setSearchTerm(event.target.value);
  // };

  // const filteredCities = cities.filter((city) =>
  //   city.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  // const [userName, setName] = useState("Welcome");
  // const [loggedIn, setLoggedIn] = useState(false);

  // useEffect(() => {
  //   const userValueObject = localStorage.hasOwnProperty("user")
  //     ? JSON.parse(localStorage.getItem("user"))
  //     : "";
  //   if (userValueObject) {
  //     setName(userValueObject.name);
  //     setLoggedIn(true);
  //   }
  // }, []);

  // function removeDataFromLocalStorage() {
  //   localStorage.clear();
  //   setName("Welcome");
  //   setLoggedIn(false);
  // }

  const navigate = useNavigate();

  const navigateCarSearch = () => {
    // 👇️ navigate to /
    navigate("/CarSearch");
  };

  return (
    <>
      {["xxl"].map((expand) => (
        <Navbar key={expand} bg="light" expand={expand} className="">
          <Container fluid>
            <div className="left-section">
              <Navbar.Toggle
                aria-controls={`offcanvasNavbar-expand-${expand}`}
                className="me-2"
              />
              <Navbar.Brand href="/">
                <img src={websiteLinks.logo} alt="" className="site_logo" />
              </Navbar.Brand>
            </div>

            <div className="right-section">
              <div className=" select_city d-flex align-items-center justify-content-center">
                <div className="col-12 d-flex justify-content-between">
                  <Button
                    onClick={() => setShowModal(true)}
                    className={
                      showModal ? "rotated select-option" : "select-option"
                    }
                  >
                    {selectedCity
                      ? selectedCity.length > 6
                        ? selectedCity.substring(0, 6) + "..."
                        : selectedCity
                      : "City"}
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.84709 5.66373L7.55784 9.45257L11.3467 5.74182"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </Button>

                  <Modal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    className="citySelect"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Select a City</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="search-container">
                        <div className="search-bar d-flex align-items-center">
                          <input
                            type="text"
                            placeholder="Search city"
                            value={searchTerm}
                            onChange={handleSearch}
                            className="form-control input-control"
                          />
                          <FaSistrix />
                        </div>
                      </div>
                      <ul className="col-12 d-flex list-unstyled flex-wrap p-0">
                        {filteredCities.map((city) => (
                          <li
                            key={city}
                            onClick={() => handleSelect(city)}
                            className="col-3 city-list"
                          >
                             <div className="city-item position-relative overflow-hidden">
                              {city == "Pune" ? (
                                <div className="inspected_badges">
                                  <div>
                                    {/* Render your badge image here */}
                                    <Image
                                      className="badge_img"
                                      src={badge}
                                      alt="Pune Badge"
                                      style={{height:"20px"}}
                                    />
                                  </div>
                                </div>
                              ) : null}
                                {city}
                              </div>
                          </li>
                        ))}
                      </ul>
                    </Modal.Body>
                  </Modal>
                </div>
              </div>
              {localStorage.hasOwnProperty("user") ? (
                <div className="col-4 d-flex align-items-center">
                  <div className="notification">
                    <NavLink to="/ShortListedCars">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 35 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M30.3914 6.72289C29.6466 5.97769 28.7622 5.38654 27.7888 4.98322C26.8154 4.5799 25.7721 4.37231 24.7185 4.37231C23.6649 4.37231 22.6216 4.5799 21.6482 4.98322C20.6748 5.38654 19.7905 5.97769 19.0456 6.72289L17.4998 8.26873L15.9539 6.72289C14.4494 5.21834 12.4088 4.37309 10.281 4.37309C8.15326 4.37309 6.11265 5.21834 4.6081 6.72289C3.10355 8.22744 2.2583 10.2681 2.2583 12.3958C2.2583 14.5236 3.10355 16.5642 4.6081 18.0687L6.15393 19.6146L17.4998 30.9604L28.8456 19.6146L30.3914 18.0687C31.1366 17.3239 31.7278 16.4395 32.1311 15.4661C32.5344 14.4927 32.742 13.4494 32.742 12.3958C32.742 11.3422 32.5344 10.2989 32.1311 9.3255C31.7278 8.35212 31.1366 7.46775 30.3914 6.72289Z"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    </NavLink>
                  </div>
                </div>
              ) : (

                <Nav.Item
                onClick={handleModalShow}
                className="login_wrap"             
              >
  
                <NavLink className="login_btn">
                  {/* Login/Register */}
                  {/* <FaLock /> */}
                 <svg class="feather feather-log-in" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" x2="3" y1="12" y2="12"/></svg>
                </NavLink>
              </Nav.Item>
              
              )}
            <LoginModal show={showLoginModal} handleClose={handleModalClose} />

              <div className="search-section" onClick={handleShow}>
                <FaSistrix style={{ fontSize: "20px" }} />
              </div>
            </div>

            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <div className="userImage">
                    <FaRegUserCircle />
                  </div>
                  <div className="UserName">
                    <h6>Hello, </h6>
                    <h6>{userName}</h6>
                  </div>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  {localStorage.hasOwnProperty("user") ? (
                    // If localStorage has a "user" property
                    <div className="top_links">
                      <NavLink
                        to="/UserProfilePage?activeTabKey=booking"
                        className="hvr-underline-from-left"
                      >
                        <span className="pe-2">
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.8337 1.83337H5.50033C5.0141 1.83337 4.54778 2.02653 4.20396 2.37034C3.86015 2.71416 3.66699 3.18048 3.66699 3.66671V18.3334C3.66699 18.8196 3.86015 19.2859 4.20396 19.6297C4.54778 19.9736 5.0141 20.1667 5.50033 20.1667H16.5003C16.9866 20.1667 17.4529 19.9736 17.7967 19.6297C18.1405 19.2859 18.3337 18.8196 18.3337 18.3334V7.33337L12.8337 1.83337Z"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.833 1.83337V7.33337H18.333"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M14.6663 11.9166H7.33301"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M14.6663 15.5834H7.33301"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M9.16634 8.25H8.24967H7.33301"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                        Bookings
                      </NavLink>
                      <NavLink
                        to="/UserProfilePage?activeTabKey=carPost"
                        className="hvr-underline-from-left"
                      >
                        <span className="pe-1">
                          <svg
                            className="me-2"
                            fill="none"
                            viewBox="0 0 24 24"
                            width="19"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.7993 3C17.2899 3 18.5894 4.01393 18.9518 5.45974L19.337 7H20.25C20.6297 7 20.9435 7.28215 20.9932 7.64823L21 7.75C21 8.1297 20.7178 8.44349 20.3518 8.49315L20.25 8.5H19.714L19.922 9.3265C20.5708 9.72128 21.0041 10.435 21.0041 11.25V19.7468C21.0041 20.7133 20.2206 21.4968 19.2541 21.4968H17.75C16.7835 21.4968 16 20.7133 16 19.7468L15.999 18.5H8.004L8.00408 19.7468C8.00408 20.7133 7.22058 21.4968 6.25408 21.4968H4.75C3.7835 21.4968 3 20.7133 3 19.7468V11.25C3 10.4352 3.43316 9.72148 4.08177 9.32666L4.289 8.5H3.75C3.3703 8.5 3.05651 8.21785 3.00685 7.85177L3 7.75C3 7.3703 3.28215 7.05651 3.64823 7.00685L3.75 7H4.663L5.04898 5.46176C5.41068 4.01497 6.71062 3 8.20194 3H15.7993ZM6.504 18.5H4.499L4.5 19.7468C4.5 19.8848 4.61193 19.9968 4.75 19.9968H6.25408C6.39215 19.9968 6.50408 19.8848 6.50408 19.7468L6.504 18.5ZM19.504 18.5H17.499L17.5 19.7468C17.5 19.8848 17.6119 19.9968 17.75 19.9968H19.2541C19.3922 19.9968 19.5041 19.8848 19.5041 19.7468L19.504 18.5ZM18.7541 10.5H5.25C4.83579 10.5 4.5 10.8358 4.5 11.25V17H19.5041V11.25C19.5041 10.8358 19.1683 10.5 18.7541 10.5ZM10.249 14H13.7507C14.165 14 14.5007 14.3358 14.5007 14.75C14.5007 15.1297 14.2186 15.4435 13.8525 15.4932L13.7507 15.5H10.249C9.83478 15.5 9.49899 15.1642 9.49899 14.75C9.49899 14.3703 9.78115 14.0565 10.1472 14.0068L10.249 14H13.7507H10.249ZM17 12C17.5522 12 17.9999 12.4477 17.9999 13C17.9999 13.5522 17.5522 13.9999 17 13.9999C16.4477 13.9999 16 13.5522 16 13C16 12.4477 16.4477 12 17 12ZM6.99997 12C7.55225 12 7.99995 12.4477 7.99995 13C7.99995 13.5522 7.55225 13.9999 6.99997 13.9999C6.4477 13.9999 6 13.5522 6 13C6 12.4477 6.4477 12 6.99997 12ZM15.7993 4.5H8.20194C7.39892 4.5 6.69895 5.04652 6.50419 5.82556L5.71058 9H18.2929L17.4968 5.82448C17.3017 5.04596 16.6019 4.5 15.7993 4.5Z"
                              fill="#212121"
                            />
                          </svg>
                        </span>
                        My Post
                      </NavLink>
                      <NavLink
                        to="/UserProfilePage?activeTabKey=myPlan"
                        className="hvr-underline-from-left"
                      >
                        <span className="pe-1">
                          <svg
                            className="me-2"
                            fill="none"
                            height="19"
                            viewBox="0 0 24 24"
                            width="19"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.7993 3C17.2899 3 18.5894 4.01393 18.9518 5.45974L19.337 7H20.25C20.6297 7 20.9435 7.28215 20.9932 7.64823L21 7.75C21 8.1297 20.7178 8.44349 20.3518 8.49315L20.25 8.5H19.714L19.922 9.3265C20.5708 9.72128 21.0041 10.435 21.0041 11.25V19.7468C21.0041 20.7133 20.2206 21.4968 19.2541 21.4968H17.75C16.7835 21.4968 16 20.7133 16 19.7468L15.999 18.5H8.004L8.00408 19.7468C8.00408 20.7133 7.22058 21.4968 6.25408 21.4968H4.75C3.7835 21.4968 3 20.7133 3 19.7468V11.25C3 10.4352 3.43316 9.72148 4.08177 9.32666L4.289 8.5H3.75C3.3703 8.5 3.05651 8.21785 3.00685 7.85177L3 7.75C3 7.3703 3.28215 7.05651 3.64823 7.00685L3.75 7H4.663L5.04898 5.46176C5.41068 4.01497 6.71062 3 8.20194 3H15.7993ZM6.504 18.5H4.499L4.5 19.7468C4.5 19.8848 4.61193 19.9968 4.75 19.9968H6.25408C6.39215 19.9968 6.50408 19.8848 6.50408 19.7468L6.504 18.5ZM19.504 18.5H17.499L17.5 19.7468C17.5 19.8848 17.6119 19.9968 17.75 19.9968H19.2541C19.3922 19.9968 19.5041 19.8848 19.5041 19.7468L19.504 18.5ZM18.7541 10.5H5.25C4.83579 10.5 4.5 10.8358 4.5 11.25V17H19.5041V11.25C19.5041 10.8358 19.1683 10.5 18.7541 10.5ZM10.249 14H13.7507C14.165 14 14.5007 14.3358 14.5007 14.75C14.5007 15.1297 14.2186 15.4435 13.8525 15.4932L13.7507 15.5H10.249C9.83478 15.5 9.49899 15.1642 9.49899 14.75C9.49899 14.3703 9.78115 14.0565 10.1472 14.0068L10.249 14H13.7507H10.249ZM17 12C17.5522 12 17.9999 12.4477 17.9999 13C17.9999 13.5522 17.5522 13.9999 17 13.9999C16.4477 13.9999 16 13.5522 16 13C16 12.4477 16.4477 12 17 12ZM6.99997 12C7.55225 12 7.99995 12.4477 7.99995 13C7.99995 13.5522 7.55225 13.9999 6.99997 13.9999C6.4477 13.9999 6 13.5522 6 13C6 12.4477 6.4477 12 6.99997 12ZM15.7993 4.5H8.20194C7.39892 4.5 6.69895 5.04652 6.50419 5.82556L5.71058 9H18.2929L17.4968 5.82448C17.3017 5.04596 16.6019 4.5 15.7993 4.5Z"
                              fill="#212121"
                            />
                          </svg>
                        </span>
                        My Plans
                      </NavLink>
                      <NavLink
                        to="/UserProfilePage?activeTabKey=viewPlan"
                        className="hvr-underline-from-left"
                      >
                        <span className="pe-1">
                          <svg
                            className="me-2"
                            fill="none"
                            height="19"
                            viewBox="0 0 24 24"
                            width="19"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.7993 3C17.2899 3 18.5894 4.01393 18.9518 5.45974L19.337 7H20.25C20.6297 7 20.9435 7.28215 20.9932 7.64823L21 7.75C21 8.1297 20.7178 8.44349 20.3518 8.49315L20.25 8.5H19.714L19.922 9.3265C20.5708 9.72128 21.0041 10.435 21.0041 11.25V19.7468C21.0041 20.7133 20.2206 21.4968 19.2541 21.4968H17.75C16.7835 21.4968 16 20.7133 16 19.7468L15.999 18.5H8.004L8.00408 19.7468C8.00408 20.7133 7.22058 21.4968 6.25408 21.4968H4.75C3.7835 21.4968 3 20.7133 3 19.7468V11.25C3 10.4352 3.43316 9.72148 4.08177 9.32666L4.289 8.5H3.75C3.3703 8.5 3.05651 8.21785 3.00685 7.85177L3 7.75C3 7.3703 3.28215 7.05651 3.64823 7.00685L3.75 7H4.663L5.04898 5.46176C5.41068 4.01497 6.71062 3 8.20194 3H15.7993ZM6.504 18.5H4.499L4.5 19.7468C4.5 19.8848 4.61193 19.9968 4.75 19.9968H6.25408C6.39215 19.9968 6.50408 19.8848 6.50408 19.7468L6.504 18.5ZM19.504 18.5H17.499L17.5 19.7468C17.5 19.8848 17.6119 19.9968 17.75 19.9968H19.2541C19.3922 19.9968 19.5041 19.8848 19.5041 19.7468L19.504 18.5ZM18.7541 10.5H5.25C4.83579 10.5 4.5 10.8358 4.5 11.25V17H19.5041V11.25C19.5041 10.8358 19.1683 10.5 18.7541 10.5ZM10.249 14H13.7507C14.165 14 14.5007 14.3358 14.5007 14.75C14.5007 15.1297 14.2186 15.4435 13.8525 15.4932L13.7507 15.5H10.249C9.83478 15.5 9.49899 15.1642 9.49899 14.75C9.49899 14.3703 9.78115 14.0565 10.1472 14.0068L10.249 14H13.7507H10.249ZM17 12C17.5522 12 17.9999 12.4477 17.9999 13C17.9999 13.5522 17.5522 13.9999 17 13.9999C16.4477 13.9999 16 13.5522 16 13C16 12.4477 16.4477 12 17 12ZM6.99997 12C7.55225 12 7.99995 12.4477 7.99995 13C7.99995 13.5522 7.55225 13.9999 6.99997 13.9999C6.4477 13.9999 6 13.5522 6 13C6 12.4477 6.4477 12 6.99997 12ZM15.7993 4.5H8.20194C7.39892 4.5 6.69895 5.04652 6.50419 5.82556L5.71058 9H18.2929L17.4968 5.82448C17.3017 5.04596 16.6019 4.5 15.7993 4.5Z"
                              fill="#212121"
                            />
                          </svg>
                        </span>
                        View Plans
                      </NavLink>
                      <NavLink
                        to="/UserProfilePage?activeTabKey=helpAndSupport"
                        className="hvr-underline-from-left"
                      >
                        <span className="pe-3">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.3337 19.25V17.4167C18.3337 16.4442 17.9474 15.5116 17.2597 14.8239C16.5721 14.1363 15.6395 13.75 14.667 13.75H7.33366C6.3612 13.75 5.42857 14.1363 4.74093 14.8239C4.0533 15.5116 3.66699 16.4442 3.66699 17.4167V19.25"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10.9997 10.0833C13.0247 10.0833 14.6663 8.44171 14.6663 6.41667C14.6663 4.39162 13.0247 2.75 10.9997 2.75C8.97463 2.75 7.33301 4.39162 7.33301 6.41667C7.33301 8.44171 8.97463 10.0833 10.9997 10.0833Z"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                        Help and Support
                      </NavLink>
                      <NavLink className="hvr-underline-from-left"  onClick={openModal}>
                      <span className="pe-3">
                                      <img
                                        src={invite}
                                        alt=""
                                        style={{
                                          width: "18px",
                                          height: "18px",
                                        }}
                                      />
                                    </span>
                        Invite Friends

                      </NavLink>
                      <InviteModal
                                    show={isModalOpen}
                                    onHide={closeModal}
                                  />
                      {loggedIn ? (
                        <NavLink
                          className="hvr-underline-from-left account-item"
                          onClick={removeDataFromLocalStorage}
                        >
                          <span className="me-2">
                            <svg
                              width="25"
                              height="25"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.25 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V4.58333C2.75 4.0971 2.94315 3.63079 3.28697 3.28697C3.63079 2.94315 4.0971 2.75 4.58333 2.75H8.25"
                                stroke="#000"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M14.667 15.5833L19.2503 11L14.667 6.41663"
                                stroke="#000"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M19.25 11H8.25"
                                stroke="#000"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                          Logout
                        </NavLink>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    // If localStorage doesn't have a "user" property
                    ""
                    /* SVG icon */
                  )}

                  <NavLink to="/About" className="hvr-underline-from-left">
                    <span className="me-2">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.58067 6.36213C4.58067 5.37825 5.37825 4.58067 6.36213 4.58067H17.5598C18.5437 4.58067 19.3413 5.37825 19.3413 6.36213V11.074C19.5842 10.9881 19.8421 10.943 20.1048 10.943C20.3673 10.943 20.6253 10.9881 20.8683 11.074V6.36213C20.8683 4.53493 19.387 3.05371 17.5598 3.05371H6.36213C4.53493 3.05371 3.05371 4.53493 3.05371 6.36213V17.5598C3.05371 19.387 4.53493 20.8683 6.36213 20.8683H11.074C10.9881 20.6253 10.943 20.3673 10.943 20.1047C10.943 19.8421 10.9881 19.5842 11.074 19.3413H6.36213C5.37825 19.3413 4.58067 18.5437 4.58067 17.5598V6.36213ZM6.10763 7.12561C6.10763 6.5634 6.5634 6.10763 7.12561 6.10763H9.16155C9.72376 6.10763 10.1795 6.5634 10.1795 7.12561V9.16155C10.1795 9.72376 9.72377 10.1795 9.16155 10.1795H7.12561C6.5634 10.1795 6.10763 9.72377 6.10763 9.16155V7.12561ZM11.7065 7.12561C11.7065 6.56339 12.1622 6.10763 12.7245 6.10763H16.7964C17.3586 6.10763 17.8143 6.5634 17.8143 7.12561V9.16155C17.8143 9.72377 17.3586 10.1795 16.7964 10.1795H12.7245C12.1622 10.1795 11.7065 9.72376 11.7065 9.16155V7.12561ZM6.10763 12.7245C6.10763 12.1622 6.56339 11.7065 7.12561 11.7065H9.16155C9.72376 11.7065 10.1795 12.1622 10.1795 12.7245V16.7964C10.1795 17.3586 9.72377 17.8143 9.16155 17.8143H7.12561C6.5634 17.8143 6.10763 17.3586 6.10763 16.7964V12.7245ZM20.6446 12.6936C20.5015 12.5504 20.3072 12.47 20.1048 12.47C19.9023 12.47 19.7081 12.5504 19.5649 12.6936L18.038 14.2206C17.7398 14.5187 17.7398 15.0021 18.038 15.3002C18.3361 15.5984 18.8195 15.5984 19.1176 15.3002L19.3413 15.0767V17.5598C19.3413 18.5436 18.5437 19.3413 17.5598 19.3413H15.0767L15.3002 19.1176C15.5984 18.8195 15.5984 18.3361 15.3002 18.038C15.0021 17.7398 14.5187 17.7398 14.2206 18.038L12.6936 19.5648C12.5504 19.7081 12.47 19.9022 12.47 20.1047C12.47 20.3072 12.5504 20.5014 12.6936 20.6446L14.2206 22.1716C14.5187 22.4697 15.0021 22.4697 15.3002 22.1716C15.5984 21.8734 15.5984 21.3901 15.3002 21.0919L15.0766 20.8683H17.5598C19.387 20.8683 20.8683 19.387 20.8683 17.5598V15.0767L21.0919 15.3002C21.3901 15.5984 21.8734 15.5984 22.1716 15.3002C22.4697 15.0021 22.4697 14.5187 22.1716 14.2206L20.6446 12.6936Z"
                          fill="#000"
                        />
                      </svg>
                    </span>
                    About Us
                  </NavLink>
                  <NavLink
                    to="/?section=how-it-works"
                    className="hvr-underline-from-left"
                    // onClick={() => handleSectionClick("how-it-works")}
                  >
                    <span className="me-2">
                      <svg
                        width="25"
                        height="26"
                        viewBox="0 0 25 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_434_2898)">
                          <path
                            d="M23.4135 5.06787V11.1757H17.3057"
                            stroke="#000"
                            stroke-width="1.39608"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M1.01807 21.3554V15.2476H7.12591"
                            stroke="#000"
                            stroke-width="1.39608"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3.57318 10.1577C4.08946 8.69871 4.96692 7.39429 6.12368 6.36615C7.28044 5.33802 8.67879 4.61966 10.1883 4.27813C11.6977 3.93659 13.2691 3.983 14.7558 4.41302C16.2425 4.84305 17.596 5.64268 18.6901 6.73729L23.4135 11.1757M1.01807 15.2476L5.74146 19.6859C6.83553 20.7805 8.18905 21.5802 9.67574 22.0102C11.1624 22.4402 12.7338 22.4866 14.2433 22.1451C15.7528 21.8035 17.1511 21.0852 18.3079 20.0571C19.4646 19.0289 20.3421 17.7245 20.8584 16.2655"
                            stroke="#000"
                            stroke-width="1.39608"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_434_2898">
                            <rect
                              width="24.4314"
                              height="24.4314"
                              fill="white"
                              transform="translate(0 0.996094)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    How it works
                  </NavLink>
                  <NavLink to="/Blog" className="hvr-underline-from-left">
                    <span className="me-2">
                      <svg
                        width="25"
                        height="26"
                        viewBox="0 0 25 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.2515 2.72656H6.10773C5.56776 2.72656 5.04991 2.94106 4.66809 3.32288C4.28628 3.70469 4.07178 4.22254 4.07178 4.76251V21.0501C4.07178 21.5901 4.28628 22.1079 4.66809 22.4897C5.04991 22.8715 5.56776 23.086 6.10773 23.086H18.3234C18.8634 23.086 19.3812 22.8715 19.763 22.4897C20.1449 22.1079 20.3594 21.5901 20.3594 21.0501V8.83441L14.2515 2.72656Z"
                          stroke="#000"
                          stroke-width="1.39608"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.2515 2.72656V8.83441H20.3593"
                          stroke="#000"
                          stroke-width="1.39608"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.2873 13.9238H8.14355"
                          stroke="#000"
                          stroke-width="1.39608"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.2873 17.9961H8.14355"
                          stroke="#000"
                          stroke-width="1.39608"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10.1795 9.85205H9.16153H8.14355"
                          stroke="#000"
                          stroke-width="1.39608"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    Blogs
                  </NavLink>
                  <NavLink
                    to="/?section=testimonial"
                    className="hvr-underline-from-left"
                    // onClick={() => handleSectionClick("testimonial")}
                  >
                    <span className="me-2">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.514 15.8591C11.6895 15.3159 11.9333 14.8034 12.2352 14.3317H6.36155C5.09694 14.3317 4.07178 15.3569 4.07178 16.6215V17.2097C4.07178 18.1188 4.39608 18.998 4.98639 19.6893C6.42405 21.3728 8.53996 22.2877 11.2895 22.4517L11.7485 20.944C9.20166 20.863 7.35181 20.1074 6.14782 18.6975C5.79364 18.2827 5.59905 17.7552 5.59905 17.2097V16.6215C5.59905 16.2004 5.94043 15.8591 6.36155 15.8591H11.514ZM12.2136 2.11816C15.0253 2.11816 17.3045 4.39748 17.3045 7.20915C17.3045 10.0208 15.0253 12.3001 12.2136 12.3001C9.402 12.3001 7.12272 10.0208 7.12272 7.20915C7.12272 4.39748 9.402 2.11816 12.2136 2.11816ZM12.2136 3.64546C10.2455 3.64546 8.64999 5.24098 8.64999 7.20915C8.64999 9.17733 10.2455 10.7729 12.2136 10.7729C14.1818 10.7729 15.7773 9.17733 15.7773 7.20915C15.7773 5.24098 14.1818 3.64546 12.2136 3.64546ZM23.4133 17.8955C23.4133 20.9883 20.9061 23.4956 17.8133 23.4956C16.8282 23.4956 15.9026 23.2413 15.0985 22.7947L12.8721 23.4722C12.4824 23.5908 12.1181 23.2266 12.2368 22.8369L12.9145 20.6111C12.4677 19.8068 12.2132 18.8808 12.2132 17.8955C12.2132 14.8026 14.7205 12.2955 17.8133 12.2955C20.9061 12.2955 23.4133 14.8026 23.4133 17.8955ZM15.7769 16.3683C15.4958 16.3683 15.2679 16.5962 15.2679 16.8774C15.2679 17.1585 15.4958 17.3864 15.7769 17.3864H19.8497C20.1308 17.3864 20.3587 17.1585 20.3587 16.8774C20.3587 16.5962 20.1308 16.3683 19.8497 16.3683H15.7769ZM15.2679 18.9137C15.2679 19.1949 15.4958 19.4228 15.7769 19.4228H17.8133C18.0945 19.4228 18.3224 19.1949 18.3224 18.9137C18.3224 18.6326 18.0945 18.4046 17.8133 18.4046H15.7769C15.4958 18.4046 15.2679 18.6326 15.2679 18.9137Z"
                          fill="#000"
                        />
                      </svg>
                    </span>
                    Testimonials
                  </NavLink>

                  {/* <NavDropdown
                    title="Dropdown"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                    <NavDropdown.Item href="#action4">
                      Another action
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action5">
                      Something else here
                    </NavDropdown.Item>
                  </NavDropdown> */}
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>

          <Modal show={showSrearchModal} onHide={handleClose}>
            <div className="d-flex align-items-center justify-content-center">
              <div className="col-12 d-flex search_block">
                <SearchBar />
              </div>
            </div>
          </Modal>
        </Navbar>
      ))}
    </>
  );
}

export default OffcanvasExample;
